import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import ProjectEditService from '../service/ProjectEditService';

const config = () => {
	return {
		key: 'projectEditForm',
		text: 'Project',
		textKey: 'project',
		service: ProjectEditService,
		tabList: [
			{
				key: 'info',
				text: 'Info',
				textKey: 'info'
			},
			{
				key: 'annotations',
				text: 'Annotations',
				textKey: 'annotations'
			}
		],
		fields: [
			{
				key: 'name',
				text: 'Name',
				textKey: 'name',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'annotations',
				text: 'Annotations',
				textKey: 'annotations',
				tab: 'annotations',
				component: EditFormGridComponent,
				defaultValue: {
					id: null,
					name: null,
					minValue: null,
					maxValue: null
				},
				fields: [
					{
						key: 'name',
						text: 'Name',
						textKey: 'name',
						component: EditFormTextField,
						required: true
					},
					{
						key: 'minValue',
						text: 'Min Value',
						textKey: 'minValue',
						component: EditFormTextField,
						type: 'number',
						required: true
					},
					{
						key: 'maxValue',
						text: 'Max Value',
						textKey: 'maxValue',
						component: EditFormTextField,
						type: 'number',
						required: true
					}
				]
			}
		]
	};
};

function ProjectEditForm() {
	const myConfig = config();
	return <EditFormPage config={myConfig} />;
}

export default ProjectEditForm;
